import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Sophie M.",
    city: "Lyon",
    text: "Grâce à E-forma, j'ai enfin osé la reconversion que je repoussais depuis 5 ans. Le suivi personnalisé m'a vraiment aidé à me lancer.",
    before: "Assistante commerciale",
    after: "Formatrice",
  },
  {
    name: "Thomas K.",
    city: "Bordeaux",
    text: "Le financement CPF a tout simplifié. En 3 mois, j'avais mon plan de carrière clair et je suis passé chef de projet.",
    before: "Commercial",
    after: "Chef de projet",
  },
  {
    name: "Isabelle R.",
    city: "Paris",
    text: "Très professionnel, disponible et à l'écoute. Je recommande vivement à toute personne qui doute de son avenir pro.",
    before: "Comptable",
    after: "Consultante RH",
  },
];

const Stars = () => (
  <div className="flex gap-0.5 text-accent">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-current" />
    ))}
  </div>
);

const TestimonialsSection = () => (
  <section className="section-padding bg-background">
    <div className="container mx-auto text-center">
      <h2 className="mb-12 text-3xl font-extrabold md:text-4xl">
        Ce Que Disent Nos Bénéficiaires
      </h2>
      <div className="grid gap-8 md:grid-cols-3">
        {testimonials.map((t) => (
          <div
            key={t.name}
            className="flex flex-col rounded-2xl border border-border bg-card p-6 shadow-sm"
          >
            <Stars />
            <blockquote className="my-4 flex-1 text-left text-muted-foreground italic">
              "{t.text}"
            </blockquote>
            <div className="mt-auto text-left">
              <p className="font-bold">{t.name}, {t.city}</p>
              <p className="text-xs text-muted-foreground">
                {t.before} → <span className="font-semibold text-primary">{t.after}</span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
